import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertCircle, Info } from 'lucide-react';

export default function Toast() {
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

    useEffect(() => {
        let timer;
        const handleShow = (e) => {
            setToast({ show: true, message: e.detail.message, type: e.detail.type });
            // Verberg automatisch na 3.5 seconden
            clearTimeout(timer);
            timer = setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 3500);
        };
        
        window.addEventListener('mywod-toast', handleShow);
        return () => {
            window.removeEventListener('mywod-toast', handleShow);
            clearTimeout(timer);
        };
    }, []);

    if (!toast.show) return null;

    const colors = {
        success: 'bg-green-600 border-green-400',
        error: 'bg-red-600 border-red-400',
        info: 'bg-blue-600 border-blue-400'
    };
    
    const icons = {
        success: <CheckCircle size={20} />,
        error: <AlertCircle size={20} />,
        info: <Info size={20} />
    };

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[99999] transition-all transform duration-300 ease-out">
            <div className={`flex items-center gap-3 px-5 py-3 rounded-xl border shadow-2xl text-white whitespace-nowrap ${colors[toast.type] || colors.info}`}>
                {icons[toast.type] || icons.info}
                <span className="font-bold text-sm tracking-wide">{toast.message}</span>
            </div>
        </div>
    );
}
